import React from 'react';

interface StatCardProps {
    title: string;
    value: number | string;
    subText?: string;
    percent?: number | string;
    description?: React.ReactNode;
    icon: React.ReactNode;
    borderColor: string;
    iconBg: string;
    iconColor: string;
    valueColor: string;
    percentColor?: string;
}

const StatCard: React.FC<StatCardProps> = ({
    title,
    value,
    subText,
    percent,
    description,
    icon,
    borderColor,
    iconBg,
    iconColor,
    valueColor,
    percentColor
}) => {
    return (
        <div
            style={{
                background: '#fff',
                borderRadius: '12px',
                padding: '16px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                borderLeft: `4px solid ${borderColor}`,
                height: '100%'
            }}
        >
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    marginBottom: '8px'
                }}
            >
                <div
                    style={{
                        width: 36,
                        height: 36,
                        borderRadius: '50%',
                        background: iconBg,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: iconColor
                    }}
                >
                    {icon}
                </div>

                <span
                    style={{
                        fontSize: '12px',
                        color: '#6b7280',
                        fontWeight: 500
                    }}
                >
                    {title}
                </span>
            </div>

            <div
                style={{
                    fontSize: '24px',
                    fontWeight: 700,
                    color: valueColor,
                    lineHeight: 1
                }}
            >
                {value}
            </div>

            {subText && (
                <div
                    style={{
                        fontSize: '11px',
                        color: '#9ca3af',
                        marginTop: '4px'
                    }}
                >
                    {subText}
                </div>
            )}

            {percent !== undefined && (
                <div
                    style={{
                        fontSize: '12px',
                        color: percentColor || valueColor,
                        marginTop: '6px',
                        fontWeight: 600
                    }}
                >
                    Tỷ lệ: {percent}
                </div>
            )}

            {description && (
                <div
                    style={{
                        marginTop: '8px',
                        fontSize: '12px'
                    }}
                >
                    {description}
                </div>
            )}
        </div>
    );
};


export default StatCard;